import type { ProductTileDisplayOptions } from "./types";

/**
 * THE tile display defaults — the organism's prop defaults, the Builder
 * inputs' `defaultValue`s and the blocks' merge all read these, so a key
 * missing from saved content can never flip a part on that the editor showed
 * as off. Everything off except price.
 *
 * Layout differs by block: a single Product Tile starts as the standard
 * storefront tile; the Featured Product Slider starts as the feature card.
 */
export const DEFAULT_TILE_DISPLAY = {
  layout: "standard",
  showBadges: false,
  showPrice: true,
  showRatings: false,
  showAddToCart: false,
  showFavorites: false,
  showMessaging: false,
  showQuickView: false,
} as const satisfies Required<Omit<ProductTileDisplayOptions, "borderColor">>;

/** The slider's defaults: the same parts, Feature layout. */
export const SLIDER_TILE_DISPLAY = {
  ...DEFAULT_TILE_DISPLAY,
  layout: "feature",
} as const satisfies Required<Omit<ProductTileDisplayOptions, "borderColor">>;
